import * as types from "../../types";

export const changeUser = (voter: string) => {
  return {
    type: types.CHANGE_USER,
    payload: voter,
  };
};
